import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import Select from '../Select'

const items = [{
  value: 'SHORT_INTEREST',
  label: 'Short interest'
}, {
  value: 'PRICE_TO_BOOK_VALUE',
  label: 'Price to book value'
}, {
  value: 'PRICE_TO_EARNINGS',
  label: 'Price to earnings'
}, {
  value: 'PRICE_TO_REVENUE',
  label: 'Price to revenue'
}]

@inject('store') @observer
class Fundamental extends Component {
  handleChange = (e) => {
    const {analysis} = this.props.store
    const value = e.target.getAttribute('value')
    if (analysis.fundamental.find(ind => ind.ident === value)) {
      analysis.removeIndicator('fundamental', value)
    } else {
      analysis.addIndicator('fundamental', value)
    }
  }
  render() {
    const {fundamental} = this.props.store.analysis
    let selected = []
    let loadingItems = []
    fundamental.map(ind => {
      selected.push(ind.ident)
      if (ind.loading) {
        loadingItems.push(ind.ident)
      }
    })
    return(
      <Select
        label='Fundamental'
        onSelect={this.handleChange}
        items={items}
        selected={selected}
        loadingItems={loadingItems}
      />
    )
  }
}

export default Fundamental
